import { render } from "./RemoveModal.vue?vue&type=template&id=ba420b7c"
import script from "./RemoveModal.vue?vue&type=script&lang=js"
export * from "./RemoveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__